import Cookies from 'js-cookie';

import { useUserService } from '../service/user';

const useUser = () => {
  const {
    getById, create, update, remove, ...restService
  } = useUserService();

  function getUserById(id: string) {
    return getById(id);
  }

  async function createUser(formData: IUser) {
    const response = await create(formData);
    return response;
  }

  async function updateUser(id: string, data: IUserPayload) {
    const response = await update(id, data);
    return response;
  }

  async function deleteUser(id: string, rowVersion: string) {
    const userLoginData = JSON.parse(Cookies.get('user_login') as string);

    const response = await remove(id, rowVersion, userLoginData.userId);
    return response;
  }

  return {
    getUserById,
    createUser,
    updateUser,
    deleteUser,
    ...restService,
  };
};

export default useUser;
